import { PropsWithChildren } from 'react'
import Styles from 'components/Wizards/SelectImages/GeneratedImage.module.scss'

export const Image = ({ children }: PropsWithChildren) => {
  return <div className={Styles.image}>{children}</div>
}
